<template>
	<header-menu-admin />
	
	<!-- Main Sections -->
	<main class="main-wrapper bg-lightest-gray">

		<!-- About Section Start -->
		<section class="about-section py-40">
			<div class="container-fluid">
				<div class="about-wrapper bg-white">
					<div class="about-block">
						<div class="table-responsive">
							<table class="table table-hover mb-0">
								<thead>
									<tr>
										<th style="vertical-align: middle;">Email</th>
										<th style="vertical-align: middle;">Фамилия</th>
										<th style="vertical-align: middle;">Имя</th>
										<th style="vertical-align: middle;">Телефон</th>
										<th style="vertical-align: middle;">Страна</th>
										<th style="vertical-align: middle;">Город</th>
										<th style="vertical-align: middle;">Индекс</th>
										<th style="vertical-align: middle;">Адрес</th>
										<th style="vertical-align: middle;">Админ</th>
										<th width="150" style="min-width: 150px; vertical-align: middle; text-align: right;">Операции</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="user in users" :key="user.id">
										<td style="vertical-align: middle;">{{user.email}}</td>
										<td style="vertical-align: middle;">{{user.lastname}}</td>
										<td style="vertical-align: middle;">{{user.firstname}}</td>
										<td style="vertical-align: middle;">{{user.phone}}</td>
										<td style="vertical-align: middle;">{{user.country}}</td>
										<td style="vertical-align: middle;">{{user.city}}</td>
										<td style="vertical-align: middle;">{{user.postalCode}}</td>
										<td style="vertical-align: middle;">{{user.address}}</td>
										<td style="vertical-align: middle;">{{user.isAdmin ? 'Да' : 'Нет'}}</td>
										<td style="vertical-align: middle; text-align: right">
											<button type="button" class="btn btn-sm btn-danger" @click="onDelete(user.id)">
												<svg width="24" height="24" fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" /></svg>
											</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div class="text-center mt-2">
						<div class="mb-1">Всего пользователей: {{users_count}}</div>
						<nav aria-label="Page navigation">
							<ul class="pagination justify-content-center mb-0">
								<li class="page-item" :class="{'disabled': page == 1}">
									<a class="page-link p-1" href="javascript://" @click="gotoPage(page - 1)" aria-label="Previous">
										<svg width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" /></svg>
									</a>
								</li>
								<li class="page-item" :class="{'active': page == 1}">
									<a class="page-link" href="javascript://" @click="gotoPage(1)">1</a>
								</li>
								<li class="page-item disabled" v-if="page - paginationAlpha > 2">
									<span class="page-link">...</span>
								</li>
								<li class="page-item" :class="{'active': page == i}" v-for="i in range(paginationA1, paginationA2)" :key="i" v-show="paginationA2 >= paginationA1">
									<a class="page-link" href="javascript://" @click="gotoPage(i)">{{i}}</a>
								</li>
								<li class="page-item disabled" v-if="page + paginationAlpha < getPagesCount() - 1">
									<span class="page-link">...</span>
								</li>
								<li class="page-item" :class="{'active': page == getPagesCount()}" v-if="getPagesCount() > 1">
									<a class="page-link" href="javascript://" @click="gotoPage(getPagesCount())">{{getPagesCount()}}</a>
								</li>
								<li class="page-item" :class="{'disabled': page == getPagesCount() || getPagesCount() == 0}">
									<a class="page-link p-1" href="javascript://" @click="gotoPage(page + 1)" aria-label="Next">
										<svg width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" /></svg>
									</a>
								</li>
							</ul>
						</nav>
					</div>
				</div>
			</div>
		</section>
		<!-- About Section End -->
	</main>
	<!-- Main Sections -->
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import HeaderMenuAdmin from '@/components/HeaderMenuAdmin';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech Admin'});
	},
	data: () => ({
		users: [],
		users_count: 0,
		
		page: 1,
		limit: 12,
		loading: true,
		error: '',
		
		paginationAlpha: 3,
	}),
	computed: {
		paginationA1(){
			return Math.max(this.page - this.paginationAlpha, 2);
		},
		paginationA2(){
			return Math.min(this.page + this.paginationAlpha, this.getPagesCount() - 1);
		},
	},
	methods: {
		range: lib.range,
		number_format(value){
			return lib.number_format(value, 0, '.', ' ');
		},
		
		async loadData(){
			this.loading = true;
			this.error = '';
			const params = {
				start: (this.page - 1) * this.limit,
				limit: this.limit,
			};
			const ret = await this.appModel.doGetUsers(params);
			if(ret.success){
				this.users = ret.list;
				this.users_count = ret.count;
			} else {
				this.error = ret.message;
			}
			this.loading = false;
		},
		
		gotoPage(page){
			if(page >= 1 && page <= this.getPagesCount() && page != this.page){
				this.page = page;
				this.loadData();
				window.scrollTo(0, 0);
			}
		},
		// получение количества страниц
		getPagesCount(){
			return Math.ceil(this.users_count / this.limit);
		},
		
		async onDelete(id){
			if(confirm('Вы уверены, что хотите удалить данного пользователя?')){
				let ret = await this.appModel.doDeleteUser(id);
				if(ret.success){
					this.loadData();
				} else {
					alert(ret.error);
				}
			}
		},
	},
	async mounted(){
		window.scrollTo(0, 0);
		
		await this.loadData();
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	components: {
		HeaderMenuAdmin,
	},
};
</script>